import { useQuery } from '@tanstack/react-query';

import { useMetaApiInstance } from '../api';
import { HOST_QUERY_KEY } from '../constants';

import type { RecentService } from '../constants';

/**
 * 현재 사용자가 최근 사용했던 서비스 목록을 제공하는 훅입니다.
 * @description
 * - Meta Api의 응답값을 react-query로 제공합니다.
 * - SSR을 지원하고 있습니다.
 * - queryKey를 기반으로 revalidate 할 수 있습니다.
 */
const useRecentServiceState = () => {
  const { fetchRecentService } = useMetaApiInstance();

  return useQuery<RecentService[]>({
    queryKey: [HOST_QUERY_KEY.GET_RECENT_SERVICE],
    queryFn: () => fetchRecentService(),
    staleTime: Infinity,
  });
};

export default useRecentServiceState;
